import React from "react";

function TextRelease() {
    return <div>TextRelease</div>;
}

export default TextRelease;
